import React from 'react';
import { Redirect } from 'react-router-dom';
import { Loader } from '@unmind/design-system';

import {
  default as useFeatureFlag,
  FEATURE_FLAGS,
} from '../../../../flags/useFeatureFlag';
import { TRenderIfAuthenticating, TRenderIfUnauthorized } from '../../types';
import { RouteConfig } from '../../../routes';
import { DefaultRoutes } from '../DefaultRoutes';

interface Props {
  route: RouteConfig;
  computedMatch: {
    url: string;
  };
  renderIfAuthenticating: TRenderIfAuthenticating;
  renderIfUnauthorized: TRenderIfUnauthorized;
}

const RedirectIfFlagDisabled = ({ route, ...props }: Props) => {
  if (
    !route.redirectIfFlagDisabled ||
    !route.redirectIfFlagDisabled.flag ||
    !route.redirectIfFlagDisabled.redirectTo
  ) {
    throw new Error(
      'RedirectIfFlagDisabled requires a flag and redirectTo property',
    );
  }

  const { flag, redirectTo } = route.redirectIfFlagDisabled;
  const isEnabled = useFeatureFlag(FEATURE_FLAGS[flag]);

  if (isEnabled === undefined) {
    return <Loader />;
  } else if (!isEnabled) {
    return <Redirect to={redirectTo} />;
  }

  return <DefaultRoutes route={route} {...props} />;
};

export default RedirectIfFlagDisabled;
